import OrganizerEditForm from "./organizer-edit-form";

const OrganizerForms = {
  Edit: OrganizerEditForm,
};

export default OrganizerForms;
